export default "__VITE_ASSET__MlajXkZt__"